import Vue from 'vue'
import VXETable from 'vxe-table'
import App from './App.vue'
import router from './router'
import store from './store'

import 'vxe-table/lib/style.css'
import '@/utils/domUtil'

Vue.use(VXETable)
import '@/permission'
import '@/core/use'

Vue.config.productionTip = false
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
